import React, { useMemo } from 'react';

import MapProductInstantPromoMessage from '../map-product-instant-promo-message/map-product-instant-promo-message';

import { useMyAccount } from '../../shared/hooks/hooks';

import { getMapEntryInstantSavingsInfo } from '../../shared/utils/cart/cart';
import { formatCurrency } from '../../shared/utils/format/format';
import {
  getMapProductInstantSavingsInfo,
  getShouldShowInstantPromotionMessage
} from '../../shared/utils/product/product';

import {
  Maybe,
  OrderEntryData,
  ProductData
} from '../../shared/types/graphql-types';

import './stacked-markdown-price.scss';

interface StackedMarkdownPriceProps {
  entry?: OrderEntryData;
  hideInstantPromo?: boolean;
  product?: Maybe<ProductData>;
  totalQuantity?: number;
}

function StackedMarkdownPrice(props: StackedMarkdownPriceProps) {
  const { entry, hideInstantPromo = false, product, totalQuantity } = props;

  const { isLoggedIn } = useMyAccount();
  let instantMapSavingsPerProduct = 0;
  let totalMapSavings = 0;

  if (entry) {
    ({ instantMapSavingsPerProduct = 0, totalMapSavings = 0 } =
      getMapEntryInstantSavingsInfo(entry, isLoggedIn, totalQuantity));
  } else {
    ({ instantMapSavingsPerProduct = 0, totalMapSavings = 0 } =
      getMapProductInstantSavingsInfo(product, isLoggedIn, totalQuantity));
  }

  const { originalPrice, percentageSaved } = useMemo(() => {
    const { promotionData = [] } = entry || {};
    const { potentialPromotions = [] } = product || {};
    const { instantPromotion, originalRetailValue } =
      (entry ? promotionData : potentialPromotions)?.find(
        promo => promo?.instantPromotion
      ) || {};

    if (instantPromotion) {
      return {
        originalPrice: instantMapSavingsPerProduct
          ? Number(originalRetailValue)
          : 0,
        percentageSaved: null
      };
    } else {
      return {
        originalPrice: Number(product?.markdownPriceData?.originalRetailValue),
        percentageSaved: product?.markdownPriceData?.formattedPercentageSaved
      };
    }
  }, [entry, instantMapSavingsPerProduct, product]);
  const showInstantPromotionMessage =
    !hideInstantPromo &&
    getShouldShowInstantPromotionMessage(
      instantMapSavingsPerProduct,
      totalQuantity
    );

  if ((isNaN(originalPrice) || originalPrice === 0) && !percentageSaved)
    return null;

  return (
    <div className="stacked-markdown-price" styleName="container">
      {showInstantPromotionMessage && (
        <MapProductInstantPromoMessage
          instantMapSavingsPerProduct={instantMapSavingsPerProduct}
          showShortDescription
          totalMapSavings={totalMapSavings}
        />
      )}
      <div className="stacked-markdown-price__markdown" styleName="markdown">
        {!isNaN(originalPrice) && (
          <div styleName="original-price">{formatCurrency(originalPrice)}</div>
        )}
        {percentageSaved && (
          <div styleName="percentage-saved">Save {percentageSaved}</div>
        )}
      </div>
    </div>
  );
}

export default StackedMarkdownPrice;
